import React from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next';
import Field from './field';
var Author = function Author(_ref) {
  var children = _ref.children,
    href = _ref.href,
    providedOnClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onMouseOver = _ref.onMouseOver;
  var onClick = usePlatformLeafEventHandler({
    fn: function fn(event, analyticsEvent) {
      return providedOnClick && providedOnClick(event, analyticsEvent);
    },
    action: 'clicked',
    componentName: 'commentAuthor',
    packageName: "@atlaskit/comment",
    packageVersion: "13.0.5"
  });
  return /*#__PURE__*/React.createElement(Field, {
    hasAuthor: true,
    href: href,
    onClick: onClick,
    onFocus: onFocus,
    onMouseOver: onMouseOver
  }, children);
};
Author.displayName = 'CommentAuthor';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Author;